export default __webpack_public_path__ + "static/media/l-durga-prasad.b6da68a1.png";